export const asArrowDownRightIcon = {
  data: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
      <path d="M4.28 3.22a.75.75 0 00-1.06 1.06L14.44 15.5H6.75a.75.75 0 000 1.5h9.5a.747.747 0 00.75-.75v-9.5a.75.75 0 00-1.5 0v7.69L4.28 3.22z" />
    </svg>
`,
  name: 'solid/arrow-down-right'
};
